var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgGraduation = function SvgGraduation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 427.063,
    viewBox: "0 0 512 427.063",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mortarboard",
    transform: "translate(0 -42.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M501.991,128.354l-241-85.031a14.992,14.992,0,0,0-9.981,0l-241,85.031a15,15,0,0,0-.034,28.279l241,85.677a14.99,14.99,0,0,0,10.048,0l241-85.677a15,15,0,0,0-.033-28.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M475.973,328.574V197.734l-30,10.665V328.574a30.118,30.118,0,0,0,0,52.242v73.716a15,15,0,0,0,30,0V380.817a30.119,30.119,0,0,0,0-52.243Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M256,273.177a44.886,44.886,0,0,1-15.073-2.6L105.444,222.412V288.42c0,16.149,16.847,29.806,50.073,40.59,28.961,9.4,64.647,14.577,100.483,14.577s71.521-5.177,100.483-14.577c33.226-10.784,50.073-24.441,50.073-40.59V222.412L271.074,270.577A44.9,44.9,0,0,1,256,273.177Z"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgGraduation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Graduation.b0957280632c15b571052068ca180c21.svg";